import Alarm from "./Alarm";

export default class AlarmSchedule extends Alarm {
	constructor(data) {
		super(data);
		this.total_events = data.total_events || 2;
	}
}
